import { render, staticRenderFns } from "./EditButtons.vue?vue&type=template&id=0bd2beb5&scoped=true&"
import script from "./EditButtons.vue?vue&type=script&lang=js&"
export * from "./EditButtons.vue?vue&type=script&lang=js&"
import style0 from "./EditButtons.vue?vue&type=style&index=0&id=0bd2beb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2beb5",
  null
  
)

export default component.exports